import React from 'react';
import { connect } from 'react-redux'

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import SphereViewer from './sphereViewer.js';
import CardInfo from './cardInfo.js'
import CardHeader from './cardHeader'

class CardBody extends React.Component{

    render(){
        let project = 'project_' + this.props.projectData.id
        let render360 = false
        let cardCategory = this.props.cardsGroup.attributes.card_category_id
        let panoramaCategory = cardCategory ? this.props.projectData.card_categories[cardCategory].attributes.panorama : false
        if (panoramaCategory) {
            render360 = true
        }

        const items = []
        var index = 0
        let nrOfImages = this.props.card.attributes.nr_of_images
        let imgSrc = ''
        for (let number = 0; number < nrOfImages; number++) {
            if (number === 0) {
                imgSrc = `/images/${project}/cards/card_${this.props.card.id}/${this.props.card.attributes.date}.jpg`
            } else {
                imgSrc = `/images/${project}/cards/card_${this.props.card.id}/${this.props.card.attributes.date}_${number.toString()}.jpg`
            }
            items.push(
                <div key={index}>
                    {render360? (
                        <div className='image-wrapper'>
                            <SphereViewer photo={imgSrc}/>
                        </div>
                    ):(
                        <TransformWrapper>
                            <TransformComponent className="main-img-zoom">
                                <div className="image-wrapper">
                                    <img className="gps-card-img" src={ imgSrc } alt="src"/>
                                </div>
                            </TransformComponent>
                        </TransformWrapper>  
                    )}
                </div>
                )
            index = index + 1;
        }

        return (
            <div>
                <div style={{ overflowY: 'hidden' }}>
                    <div className="gps-card-layout card-subcolor">
                        <div className="card-section">
                            <CardHeader card={this.props.card} cardsGroup={this.props.cardsGroup} rev={this.props.rev}/>
                            <Carousel showArrows={true} showThumbs={false}>
                                {items}                           
                            </Carousel>
                            <CardInfo card={this.props.card} cardsGroup={this.props.cardsGroup}/>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        popup       : state.popup
    }
}

export default connect(mapStateToProps)(CardBody)